import React from 'react';

import Alert from 'ui/Alert';
import Link from 'ui/Link';

import { websiteLinkTo } from '../../utils/routes';
import { useCurrentUser } from '../../utils/user';

// TODO: Rename component to ...Alert
const NonCustomerCannotSaveBanner: React.FC = () => {
  const { user } = useCurrentUser();

  if (user && !user.has_active_subscription && !user.can_update_sankeys) {
    return (
      <Alert
        status="warning"
        title={
          <>
            Please{' '}
            <Link
              href={websiteLinkTo('/subscriptions/')}
              variant="subtle"
              isExternal
            >
              subscribe
            </Link>{' '}
            to be able to save your diagrams and create new ones
          </>
        }
      />
    );
  }

  return null;
};

export default NonCustomerCannotSaveBanner;
